const baseUrl = process.env.REACT_APP_GET_BASE_URL;

export const ApiFunction = async (typeofRequest, url, body) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: typeofRequest,
    headers: myHeaders,
    redirect: "follow",
  };
  requestOptions = body !== undefined ? { ...requestOptions, body: body } : requestOptions;

  try {
    const res = await fetch(url, requestOptions);
    const data = await res.json();
    return data;
  } catch (err) {
    console.error(err);
  }
};

export const BaseApiFunction = async ({ method, endpoint, body, thirdPartUrl }) => {
  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method,
      body: body,
      headers: myHeaders,
      redirect: "follow",
    };

    const url = thirdPartUrl ? `${thirdPartUrl}${endpoint}` : `${baseUrl}${endpoint}`;

    const res = await fetch(url, requestOptions);
    const data = await res.json();

    const isSuccess = res.status === 200 || res.status === 201 || res.status === 202;

    if (isSuccess) {
      return {
        isSuccess,
        message: data.message ?? "Success",
        data,
      };
    }

    return {
      isSuccess,
      message: data.message ?? "Something went wrong!",
      data,
    };
  } catch (error) {
    return {
      isSuccess: false,
      message: error.toString() ?? "Something went wrong!",
      data: null,
    };
  }
};
